module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/png/preview_de-8d3f061510bf299d39bb3a1105f70d2f.png";